
import * as Yup from 'yup'

export const applicationManufacturerSchema = Yup.object({
    manufacturerName: Yup.string().trim().required().label('Manufacturer Name'),
    manufacturerAddress: Yup.string().trim().required().label('Manufacturer Address'),
    manufacturerPerson: Yup.string().trim().required().label('Representative'),
    manufacturerPersonDesignation: Yup.string().trim().required().label('Designation'),
    manufacturerTel: Yup.string().trim().required().label('Telephone No'),
    manufacturerFax: Yup.string().trim().label('Fax No'),
    manufacturerEmail:Yup.string().trim().email('Valid email address required.').required().label('Email'),
    manufacturerWebsite: Yup.string().trim().label('Website'),
    manufacturerLetterAttachment: Yup.number().integer().label('Letter Attachment'),
});
